import React, { useEffect, useState } from "react";
import { Button, Image, Modal, Spin, Upload } from "antd";
import {
  UploadOutlined,
  PictureOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { useToast } from "../toast";
import api from "../../api";

// ─── Медиа сангийн Modal ──────────────────────────────
function MediaPickerModal({ open, onClose, onSelect }) {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const toast = useToast();

  useEffect(() => {
    if (!open) return;
    const fetchMedia = async () => {
      setLoading(true);
      const res = await api.media_list();
      // console.log("media_list --->", res.data);
      if (res?.status === 200) {
        setImages(res.data);
      } else {
        toast("Медиа авахад алдаа гарлаа", "error");
      }
      setLoading(false);
    };
    fetchMedia();
  }, [open]);

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      title="Зургийн сан"
      width={680}
    >
      {loading ? (
        <div style={{ textAlign: "center", padding: 48 }}>
          <Spin />
        </div>
      ) : (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            gap: 8,
            maxHeight: 420,
            overflowY: "auto",
            padding: 4,
          }}
        >
          {images.length === 0 ? (
            <div
              style={{
                gridColumn: "span 4",
                textAlign: "center",
                color: "#999",
                padding: 48,
              }}
            >
              Зураг байхгүй байна
            </div>
          ) : (
            images.map((img) => (
              <div
                key={img.uid}
                onClick={() => {
                  onSelect(img.url);
                  onClose();
                }}
                style={{
                  cursor: "pointer",
                  border: "2px solid transparent",
                  borderRadius: 6,
                  overflow: "hidden",
                  transition: "border-color 0.15s",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.borderColor = "#1677ff")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.borderColor = "transparent")
                }
              >
                <img
                  src={img.thumbUrl || img.url}
                  alt=""
                  style={{
                    width: "100%",
                    height: 80,
                    objectFit: "contain",
                    display: "block",
                  }}
                />
              </div>
            ))
          )}
        </div>
      )}
    </Modal>
  );
}

// ─── ImageUpload — гол component ─────────────────────
export default function ImageUpload({
  value,
  onChange,
  size = 100,
  accept = "image/jpeg,image/png,image/webp",
}) {
  const [uploading, setUploading] = useState(false);
  const [mediaOpen, setMediaOpen] = useState(false);
  const toast = useToast();

  const handleUpload = async ({ file }) => {
    setUploading(true);
    const formData = new FormData();
    formData.append("image", file);
    const res = await api.upload_image(formData);
    if (res?.status === 201) {
      onChange(res.data.url);
      toast("Зураг амжилттай байршлаа", "success");
    } else {
      toast(res?.data?.message || "Зураг байршуулахад алдаа гарлаа", "error");
    }
    setUploading(false);
  };

  return (
    <>
      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        {/* ── Preview ── */}
        {value ? (
          <div style={{ position: "relative", width: size }}>
            <Image
              src={value}
              width={size}
              height={size}
              style={{
                objectFit: "contain",
                border: "1px solid #f0f0f0",
                borderRadius: 5,
              }}
              preview={{ mask: "Харах" }}
            />
            <Button
              size="small"
              danger
              icon={<DeleteOutlined />}
              style={{
                position: "absolute",
                top: 4,
                right: 4,
                padding: "0 4px",
                lineHeight: 1,
              }}
              onClick={() => onChange(null)}
            />
          </div>
        ) : (
          <div
            style={{
              width: size,
              height: size,
              borderRadius: 6,
              border: "1px dashed #d9d9d9",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: 4,
              color: "#bbb",
              background: "#fafafa",
            }}
          >
            <PictureOutlined style={{ fontSize: 22 }} />
          </div>
        )}

        {/* ── Buttons ── */}
        <div style={{ display: "flex", gap: 8 }}>
          <Button
            icon={<PictureOutlined />}
            size="small"
            onClick={() => setMediaOpen(true)}
          >
            Зургийн cангаас
          </Button>

          <Upload
            showUploadList={false}
            accept={accept}
            customRequest={handleUpload}
            disabled={uploading}
          >
            <Button icon={<UploadOutlined />} loading={uploading} size="small">
              Компьютераас
            </Button>
          </Upload>
        </div>
      </div>

      <MediaPickerModal
        open={mediaOpen}
        onClose={() => setMediaOpen(false)}
        onSelect={onChange}
      />
    </>
  );
}
